import customParseFormat from 'dayjs/plugin/customParseFormat';
import dayjs from 'dayjs';

import { FUTURE, PAST_YEAR, PRESENT, TIMELINE_PATHNAME } from 'timeline/enums/constants';
import { getTimelineTimePeriod } from 'timeline/utils/getTimelineTimePeriod';
import { parseSeasonYear } from 'shared/utils/getYear';
import { localizeDate } from './localizeDate';

dayjs.extend(customParseFormat);

export const getGridReleaseDateDisplay = (
  releaseDate: number,
  season: string,
  { query, asPath, pathname },
) => {
  const timelineTimePeriod = getTimelineTimePeriod({ asPath, query, pathname });

  const parseFormat = 'YYYYMMDD';
  const formattedDate = dayjs(`${releaseDate}`, parseFormat);

  if (season && pathname !== TIMELINE_PATHNAME) {
    return parseSeasonYear(season);
  }

  if (formattedDate.locale('en').format('MMM DD YYYY') === 'Invalid Date') {
    return '';
  }

  if (timelineTimePeriod === PAST_YEAR) {
    return formattedDate.format(localizeDate('MMM DD'));
  }

  if (timelineTimePeriod === FUTURE || timelineTimePeriod === PRESENT) {
    return formattedDate.format(localizeDate('MMM DD YYYY'));
  }

  const currentYear = dayjs().locale('en').year().toString();
  return currentYear === formattedDate.format('YYYY')
    ? formattedDate.format(localizeDate('MMM DD'))
    : formattedDate.format(localizeDate('YYYY'));
};
